export default __webpack_public_path__ + "static/media/businesscore2.ea29bab4.png";